module.exports = __webpack_public_path__ + "static/media/status-inhouse.6324ba40.svg";